/**
 * Add a "copy text" feature to a input field. 
 * @param element the input field containing the text
 * @param trigger the button to trigger copying
 */
const addCopyTextListener = (element: HTMLInputElement, trigger: HTMLButtonElement ) => {
    trigger.addEventListener('click', () => {
        element.focus()
        element.setSelectionRange(0, element.value.length)
        document.execCommand("copy")
        element.setSelectionRange(0, 0)

        const text = trigger.innerText

        const initialTriggerWidth = trigger.style.width
        const initialTriggerHeight = trigger.style.height
        trigger.style.width = trigger.getBoundingClientRect().width + 'px'
        trigger.style.height = trigger.getBoundingClientRect().height + 'px'

        trigger.innerText = ''
        trigger.classList.add('glyph', 'checkmark', 'shared')
        trigger.disabled = true

        setTimeout(() => {
            trigger.classList.remove('glyph', 'checkmark', 'shared')
            trigger.innerText = text
            trigger.disabled = false
            trigger.style.width = initialTriggerWidth
            trigger.style.height = initialTriggerHeight
        }, 1500)
    })
}

export { addCopyTextListener }